<template>
	<div class="row gx-2 gy-1 feature-list mb-3">
		<div class="col-6 col-lg-4 no-wrap text-truncate">
			<i class="mdi mdi-engine-outline"></i>{{ refData[car.ad.fuel] }}
		</div>
		<div class="col-6 col-lg-4">
			<i class="mdi mdi-car-shift-pattern"></i>{{ refData[car.ad.gearbox] }}
		</div>
		<div class="col-6 col-lg-4">
			<i class="mdi mdi-speedometer"></i>{{ car.ad.power }} kW ({{
				getCarPs(car.ad.power)
			}}
			Ps)
		</div>
		<div class="col-6 col-lg-4 text-truncate">
			<i class="mdi mdi-palette"></i
			>{{ car.ad.exteriorColor ? refData[car.ad.exteriorColor] + '  / ' : ''
			}}{{ car.ad.manufacturerColorName }}
		</div>
		<div class="col-6 col-lg-4" v-if="car.ad.condition === 'USED'">
			<i class="mdi mdi-counter"></i>
			{{ getPrice(car.ad.mileage) }} Km
		</div>
		<div class="col-6 col-lg-4" v-if="car.ad.condition === 'USED'">
			<i class="mdi mdi-calendar"></i>
			{{ getFirstRegistrationDate(car.ad.firstRegistration) }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'ListItemFeatures',
	props: {
		car: Object,
		refData: Object,
	},
}
</script>

<style scoped></style>
